<template>
  <Transition name="modal-animation">
    <div v-if="modalActive" class="modal" @click="close">
      <Transition name="modal-animation-inner">
        <div v-if="modalActive" class="modal__inner" @click.stop>
          <div class="modal__inner_content">
            <slot name="header" />
            <slot name="main" />
          </div>

          <div v-if="showButtons" class="modal__inner_buttons">
            <button class="btn-ok" @click="accept">
              <slot name="button-ok">
                {{ $t('Ok') }}
              </slot>
            </button>

            <button class="btn-cancel" @click="close">
              <slot name="button-cancel">
                {{ $t('cancel') }}
              </slot>
            </button>
          </div>

          <VBtn icon small class="modal__inner_close" :class="{ 'inner-close-iframe' : $route.meta.iframe }" @click="close">
            <img :src="require('../assets/img/test/close.svg')">
          </VBtn>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import { toRefs, watch } from '@vue/composition-api';

export default {
  name: 'Modal',
  props: {
    modalActive: {
      type: Boolean,
      required: true,
    },
    showButtons: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  setup(props, { emit }) {
    const { modalActive } = toRefs(props);

    const close = () => {
      emit('close');
      document.documentElement.style.overflow = '';
    };

    const accept = () => {
      emit('accept');
      document.documentElement.style.overflow = '';
    };

    watch(modalActive, (newValue) => {
      if (newValue) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = '';
      }
    });

    return {
      close,
      accept,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  &__inner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    min-height: 160px;

    @media screen and (max-width: 599px) {
      width: 100%;
      margin-top: 40px;
    }

    &_content {
      color: #212121;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }

    &_buttons {
      display: flex;
      background-color: #fff;
      padding: 30px;
      gap: 30px;
      button {
        width: 100%;
      }
    }

    &_close {
      position: absolute;
      top: 20px;
      right: 28px;
      cursor: pointer;
      width: 15px;
      img {
        width: 25px;
      }
    }
  }
}
.inner-close-iframe {
  @media screen and (max-width: 428px) {
    top: 10px !important;
    right: 10px !important;
  }
}

.btn-ok {
  padding: 10px 20px;
  border-radius: 4px;
  background: #1FC57F;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border: none;
  cursor: pointer;
}

.btn-cancel {
  padding: 8px 20px;
  border-radius: 4px;
  background: #F3F3F3;
  color: #212121;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border: none;
  cursor: pointer;
}

.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}

.modal-animation-inner-enter-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}

.modal-animation-inner-leave-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-inner-enter-from {
  opacity: 0;
  transform: scale(0.8);
}

.modal-animation-inner-leave-to {
  transform: scale(0.8);
}
</style>

<i18n locale="en" lang="yaml">
  ok: Ok
  cancel: Cancel
</i18n>

<i18n locale="ru" lang="yaml">
  ok: Ок
  cancel: Отмена
</i18n>
